import {PermissionBase} from "./permissionBase";
import {Role} from "./enum/role";
import {ModuleRolePermissionService} from "./services/moduleRolePermission.service";
import {DbUserPermission} from "./dbUserPermission";

export class PermissionsFactory {
    public static instance: PermissionBase;
    constructor() {}
    public static getInstance() {
        if (this.instance) {
            return this.instance;
        } else {
            const role = localStorage.getItem('role');

            // this.instance = new DbUserPermission(moduleRo)

            // switch(roles[0]) {
            //     case Role.ROLE_SUPER_ADMIN:
            //         this.instance = new SuperuserPermission();
            //         break;
            //
            //     default:
            //         this.instance = new UnknownPermission();
            //     break;
            // }
        }
    }
}
